import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { memoize } from "decko";

const phoneNumberUtil = PhoneNumberUtil.getInstance();

export default class PhoneNumbers {
  @memoize
  static normalize([phone, countryCode]) {
    let parsedPhone;

    try {
      parsedPhone = phoneNumberUtil.parse(phone);
    } catch (errorA) {
      if (countryCode) {
        try {
          parsedPhone = phoneNumberUtil.parse(phone, countryCode);
        } catch (errorB) {
          return null;
        }
      } else {
        return null;
      }
    }
    if (phoneNumberUtil.isValidNumber(parsedPhone)) {
      return phoneNumberUtil.format(parsedPhone, PhoneNumberFormat.E164);
    }

    return null;
  }
}
